import { Page, PageTitleWithButton } from '../../../components';
import { PDFWebViewer } from '../../../components/pdf-viewer/PDFWebviewer';
import { useState } from 'react';

export const ContractManagementPdfPOC = () => {
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  return (
    <Page title="Contract Management PDF Viewer">
      <PageTitleWithButton
        pageTitleProps={{
          title: 'Contract Management PDF Viewer'
        }}
        button={
          <>
            <select
              id="select"
              style={{ width: '100%' }}
              value={selectedFile || ''}
              onChange={e => {
                setSelectedFile(e.target.value);
              }}
            >
              <option value="" disabled selected>
                Select a file
              </option>
              <option value="/BuilderLinq Contract.pdf">With Annotations</option>

              <option value="/BuilderLinq Contract 2025-04-01 copy (1).pdf">
                Without Annotations
              </option>
            </select>
            {selectedFile === '/BuilderLinq Contract 2025-04-01 copy (1).pdf' && (
              <button id="load-annotations">Load Annotations</button>
            )}
          </>
        }
      />
      <PDFWebViewer />
    </Page>
  );
};
